import React from 'react';
import { Flame, TrendingUp, Calendar } from 'lucide-react';
import { COMMIT_DATA } from '../../data/config';
import WidgetContainer from '../WidgetContainer';

const CommitStreak = ({ delay = 0 }) => {
  // Generate heatmap data for last 12 weeks
  const generateHeatmapData = () => {
    const data = [];
    for (let week = 0; week < 12; week++) {
      const weekData = [];
      for (let day = 0; day < 7; day++) {
        weekData.push(Math.floor(Math.random() * 5)); // 0-4 contribution levels
      }
      data.push(weekData);
    }
    return data;
  };

  const heatmapData = generateHeatmapData();

  return (
    <WidgetContainer size="2x2" delay={delay}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-cream-100">Commit Streak</h3>
        <Flame className="w-5 h-5 text-orange-500 animate-glow" />
      </div>

      {/* Streak Stats */}
      <div className="grid grid-cols-3 gap-3 mb-6">
        <div className="bg-coffee-700/30 rounded-lg p-3 text-center">
          <div className="text-2xl font-bold text-orange-400">{COMMIT_DATA.currentStreak}</div>
          <div className="text-xs text-coffee-200">Current</div>
        </div>
        <div className="bg-coffee-700/30 rounded-lg p-3 text-center">
          <div className="text-2xl font-bold text-cream-100">{COMMIT_DATA.longestStreak}</div>
          <div className="text-xs text-coffee-200">Longest</div>
        </div>
        <div className="bg-coffee-700/30 rounded-lg p-3 text-center">
          <div className="text-2xl font-bold text-cream-100">{COMMIT_DATA.totalCommits}</div>
          <div className="text-xs text-coffee-200">Total</div>
        </div>
      </div>

      {/* Language Breakdown */}
      <div className="mb-4">
        <h4 className="text-sm font-medium text-coffee-200 mb-3 flex items-center gap-2">
          <TrendingUp className="w-4 h-4" />
          Language Breakdown
        </h4>
        <div className="space-y-2">
          {COMMIT_DATA.languageBreakdown.map((lang) => (
            <div key={lang.name}>
              <div className="flex justify-between text-xs mb-1">
                <span className="text-coffee-200">{lang.name}</span>
                <span className="text-cream-100 font-medium">{lang.percentage}%</span>
              </div>
              <div className="h-2 bg-coffee-700/30 rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full transition-all duration-500"
                  style={{
                    width: `${lang.percentage}%`,
                    backgroundColor: lang.color
                  }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Contribution Heatmap */}
      <div>
        <h4 className="text-sm font-medium text-coffee-200 mb-3 flex items-center gap-2">
          <Calendar className="w-4 h-4" />
          Last 12 Weeks
        </h4>
        <div className="flex gap-1">
          {heatmapData.map((week, weekIndex) => (
            <div key={weekIndex} className="flex flex-col gap-1">
              {week.map((level, dayIndex) => (
                <div
                  key={dayIndex}
                  className={`heatmap-cell heatmap-level-${level}`}
                  title={`${level} contributions`}
                ></div>
              ))}
            </div>
          ))}
        </div>
        <div className="flex justify-between text-xs text-coffee-300 mt-2">
          <span>Less</span>
          <span>More</span>
        </div>
      </div>
    </WidgetContainer>
  );
};

export default CommitStreak;
